import { makeStyles } from 'tss-react/mui';
import React from 'react';
import palette from '@ui/palette';

export interface TextLinkButtonProps {
  'aria-label': string;
  children: React.ReactNode;
  onClick: () => void;
  'data-variant'?: string;
}

const useStyles = makeStyles()(() => ({
  button: {
    padding: 0,
    border: 'none',
    width: 'inherit',
    color: palette.gray_0,
    '&:focus-visible': {
      color: palette.mint_200,
    },
    textDecoration: 'underline',
  },
}));

const TextLinkButton = (props: TextLinkButtonProps) => {
  const {
    children,
    onClick,
    'aria-label': ariaLabel,
    'data-variant': dataVariant,
  } = props;
  const { classes } = useStyles();
  return (
    <button
      type="button"
      aria-label={ariaLabel}
      className={classes.button}
      onClick={onClick}
      data-variant={dataVariant}
    >
      {children}
    </button>
  );
};

export default TextLinkButton;
